<script>
  // Edit page index.svelte
  import fileTemplateState from "../stores/fileTemplateJsonData"
  import CustomFont from "./modules/customFont/index.svelte"
  import ImgSection from "./Components/imgSection.svelte"
  import Layers from "./Components/layers.svelte"
  import NavBar from "./Components/navBar.svelte"
  import TitleCard from "./Components/titleCard.svelte"
  import UploadFile from "./modules/BaseImage/index.svelte"
  import Footer from "./Components/footer.svelte"
  import { onDestroy, onMount } from "svelte"
  import AddFontToList from "./modules/addFontToList/index.svelte"
  import defaultFonts from "../stores/fileTemplateDefaultFonts"
  import { push } from "svelte-spa-router"
  import { querystring } from "svelte-spa-router"
  import { queryStringToJSON } from "../../../../Script/queryString"
  import { loadCSS, loadJs } from "../../../../Script/loadLibrary"
  import ApplicationState from "../../../../Stores/applicationStates"
  import axios from "axios"
  import notify from "../../../../Script/notify"
  import QRCode from "qrcode"
  import ModalDelete from "./modules/modalDelete/index.svelte"
  import GoBackModal from "./modules/gobackModal/index.svelte"
  import FileTempModal from "./modules/fileTempStateModal/index.svelte"
  import { flatenObject } from "../../../../Script/flatenObject"
  import LoadingScreen from "../../../../Pages/Publish/SinglePublish/Components/loadingScreen.svelte"
  import { deleteRequest, getRequest } from "../../../../Script/apiMethods"
  /**
   * @type {Boolean} -Whether to show the editor or not
   */
  let showEditor = false
  /**
   * @type {Boolean} -Whether to show the templateModal or not
   */
  let fileTempModal = false
  /**
   * @type {Number}
   */
  let countdown = 10
  let query
  let apiLayers
  let tempLayers
  let localfileTemplateState
  let apiFontIds
  let loading = false

  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  onMount(async () => {
    try {
      loading = true

      // fileTempInitialState()
      $fileTemplateState.showImageSection = false

      query = queryStringToJSON($querystring)
      checkResolution()

      if (query.id == "000000000000000000000000") {
        fileTempInitialState()
        // await fetchDocumentList()
        return
      } else {
        if ($fileTemplateState.baseImageInfo.id != query.id) {
          await onDifferIdCondition()
        } else {
          await onSameIdCondition()
        }

        await fetchSingleDocTemp()

        if (!$fileTemplateState.baseImageInfo.palette.length) {
          // Load the extract colors script if not already loaded
          await loadJs("extractor", "assets/lib/extract-colors.min.js")

          let clrs = await extractColors($fileTemplateState.baseImageInfo.uri)

          // Limit the palette to the first 6 colors
          for (let i = 0; i < clrs.length; i++) {
            if (i < 6) $fileTemplateState.baseImageInfo.palette.push(clrs[i].hex)
          }
        }

        // if ($fileTemplateState.operations.length) {
        //   let flatObject = flatenObject($fileTemplateState.parsedJson)

        //   for (let i = 0; i < $fileTemplateState.operations.length; i++) {
        //     if ($fileTemplateState.operations[i].type == "text") {
        //       if (flatObject[$fileTemplateState.operations[i].attribute] != undefined) {
        //         $fileTemplateState.operations[i].value = flatObject[$fileTemplateState.operations[i].attribute] ? flatObject[$fileTemplateState.operations[i].attribute] : "Text"
        //       }
        //     }
        //   }
        // }
      }
      $fileTemplateState.showImageSection = true
    } catch (error) {
      console.error(error)
      const info = "PAGE: File template Editor\nEVENT: onMount"
      notify.danger(error, info)
      push("/templates/file")
    } finally {
      loading = false
    }
  })

  const onDifferIdCondition = async () => {
    try {
      // Fetching file template
      await fetchFileTemplate()

      $defaultFonts.selectedFonts = ["Arial", "Arial Black", "Courier New", "Comic Sans MS", "Times New Roman", "Impact", "Tahoma", "Verdana"]

      //loading Fonts
      await loadFontLibrary()

      // Loading base Image
      let image = await loadImage($fileTemplateState.baseImageInfo.uri)

      $fileTemplateState.baseImageInfo.height = image.naturalHeight
      $fileTemplateState.baseImageInfo.width = image.naturalWidth

      // redraw image and qr layers
      await redrawImageLayers()

      // getting initial operation values
      if ($fileTemplateState.operations.length) {
        let flatObject = flatenObject($fileTemplateState.parsedJson)

        for (let i = 0; i < $fileTemplateState.operations.length; i++) {
          if ($fileTemplateState.operations[i].type == "text") {
            if (flatObject[$fileTemplateState.operations[i].attribute]) {
              $fileTemplateState.operations[i].value = flatObject[$fileTemplateState.operations[i].attribute]
            } else {
              if (!$fileTemplateState.operations[i].value) $fileTemplateState.operations[i].value = ""
            }
          }
        }
      }

      $fileTemplateState.tempOperation = JSON.parse(JSON.stringify($fileTemplateState.operations))

      localStorage.setItem("P2BFileTempEditor", JSON.stringify($fileTemplateState))
    } catch (error) {
      throw error
    }
  }

  const loadFontList = () => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        const { data } = await axios.get("/api/swagger/v2/fonts", {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })
        // Error checking while API call
        if (data.error && !data.success) {
          throw data.errorCode
        }

        let fontList = [...data.fonts]

        $fileTemplateState.fonts = []

        for (let i = 0; i < $fileTemplateState.operations.length; i++) {
          if ($fileTemplateState.operations[i].type == "text") {
            for (let j = 0; j < fontList.length; j++) {
              if (fontList[j].name == $fileTemplateState.operations[i].fontFamily) {
                $fileTemplateState.fonts = [...$fileTemplateState.fonts, fontList[j].id]
              }
            }
          }
        }
        $fileTemplateState.fonts = [...new Set($fileTemplateState.fonts)]
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  const fetchSingleFont = (fontID) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        const { data } = await axios.get(`/api/swagger/v2/fonts/${fontID}`, {
          headers: {
            "x-access-token": $ApplicationState.token,
          },
        })

        //error checking while api call
        if (data.error && !data.success) {
          if (data.errorCode == "P2BCODE::FONT_DOES_NOT_EXIST") resolve("Arial")
          else throw data.errorCode
        }
        await loadCSS(data.font.name, data.font.uri)

        resolve(data.font.name)
      } catch (error) {
        reject(error)
      }
    })
  }

  const onSameIdCondition = async () => {
    try {
      // Fetching file template
      await fetchFileTemplate()
      await loadFontList()

      localfileTemplateState = JSON.parse(localStorage.getItem("P2BFileTempEditor"))

      tempLayers = localfileTemplateState.operations

      compareOperation()

      if (!fileTempModal) await onStartAgain()
    } catch (error) {
      throw error
    }
  }

  const compareOperation = () => {
    if (apiLayers.length == tempLayers.length) {
      for (let i = 0; i < apiLayers.length; i++) {
        for (const [apikey, apivalue] of Object.entries(apiLayers[i])) {
          if (apikey == "fontStyles") {
            // Array condition
            if (JSON.stringify(apivalue) != JSON.stringify(tempLayers[i][apikey])) {
              fileTempModal = true
              break
            }
          } else {
            // String condition
            if (apivalue != tempLayers[i][apikey]) {
              fileTempModal = true
              break
            }
          }
        }
      }
    } else {
      fileTempModal = true
    }
  }

  const fileTempInitialState = () => {
    $fileTemplateState = {
      documentTemplateId: undefined,
      documentTempName: "None",
      baseImageUploadModal: true,
      showImageSection: false,
      runWatcher: false,
      baseImageInfo: {
        palette: [],
      },
      fonts: [],
      tempOperation: [],
      activeFontFamily: "Arial",
      operations: [],
      download: false,
      canvasScale: 0,
      canvasHeight: 0,
      parsedJson: {},
      templateDel: false,
      goBack: false,
      apiFonts: [],
      footerArray: ["You can change the quality in settings", "You can Able to change File template name", "Add or Edit, Text, Image and qr elements", "You can Add custom fonts for text layers", "Able to Download the canvas"],
    }
    $fileTemplateState.baseImageInfo.Quality = 0.97
    $fileTemplateState.baseImageInfo.rangeValue = 87
    localStorage.setItem("P2BFileTempEditor", JSON.stringify($fileTemplateState))
  }

  const fetchSingleDocTemp = async () => {
    try {
      const { template } = await getRequest(`/api/swagger/v2/templates/documents/${$fileTemplateState.documentTemplateId}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      // nested objects - double parse
      $fileTemplateState.parsedJson = JSON.parse(JSON.parse(JSON.stringify(template.metadata)))
      $fileTemplateState.parsedJson.url = "https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592"
      $fileTemplateState.parsedJson.expireOn = new Date(new Date().setDate(new Date().getDate() + 1)).toDateString().slice(4)
      $fileTemplateState.parsedJson.date = new Date().toDateString().slice(4)
      $fileTemplateState.parsedJson.documentID = "67d4e8f0b3c74621fa9e5b7c"

      $fileTemplateState.parsedJson = { ...$fileTemplateState.parsedJson, Others: "" }
    } catch (error) {
      $fileTemplateState.documentTemplateId = undefined
      throw error
    }
  }

  // fetych particular document template
  const fetchFileTemplate = async () => {
    try {
      $fileTemplateState.templateDel = false

      const { template } = await getRequest(`/api/swagger/v2/templates/files/${query.id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      $fileTemplateState.baseImageInfo.name = $fileTemplateState.baseImageInfo.tempName = template.name
      if ($fileTemplateState.baseImageInfo.id != query.id || !$fileTemplateState.baseImageInfo.id) {
        $fileTemplateState.operations = JSON.parse(template.layers)
        $fileTemplateState.fonts = JSON.parse(template.fonts)

        for (let i = 0; i < $fileTemplateState.operations.length; i++) {
          $fileTemplateState.operations[i].id = i
          $fileTemplateState.operations[i].active = false
          $fileTemplateState.operations[i].hover = false
        }
      }

      $fileTemplateState.baseImageInfo.id = template.id

      // end
      $fileTemplateState.documentTemplateId = template.document
      $fileTemplateState.baseImageInfo.palette = JSON.parse(template.palette)
      $fileTemplateState.baseImageInfo.uri = template.baseUri
      $fileTemplateState.baseImageInfo.uploadedTime = template.created
      // $fileTemplateState.fonts = JSON.parse(template.fonts)
      apiFontIds = JSON.parse(template.fonts)
      apiLayers = JSON.parse(template.layers)
      $fileTemplateState.baseImageInfo.Quality = template.quality
      $fileTemplateState.baseImageInfo.rangeValue = Math.floor(template.quality * 1000) / 10

      $fileTemplateState.baseImageUploadModal = false
    } catch (error) {
      throw error
    }
  }

  const loadImage = (uri) => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
        const { data } = await axios.get(uri, { timeout: 5000, responseType: "blob" })
        let localUri = URL.createObjectURL(data)
        let img = new Image()
        img.onload = () => {
          resolve(img)
        }
        img.onerror = (error) => {
          push("/templates/file")
          reject("Image failed to load.")
        }
        img.src = localUri
      } catch (error) {
        reject(error)
      }
    })
  }

  const loadFontLibrary = () => {
    return new Promise(async (resolve, reject) => {
      try {
        for (let i = 0; i < $fileTemplateState.fonts.length; i++) {
          let newFontname = await fetchSingleFont($fileTemplateState.fonts[i])

          $defaultFonts.selectedFonts = [...$defaultFonts.selectedFonts, newFontname]

          $defaultFonts.selectedFonts.sort()
          $defaultFonts.selectedFonts = [...new Set($defaultFonts.selectedFonts)]

          $fileTemplateState.apiFonts = [...$fileTemplateState.apiFonts, newFontname]
          $fileTemplateState.apiFonts = [...new Set($fileTemplateState.apiFonts)]
        }
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  const checkResolution = () => {
    if (window.innerWidth > 1023) {
      showEditor = true
    } else {
      showEditor = false
      setTimeout(() => {
        push("/templates/file")
      }, 10000)
    }
  }

  const onResume = async () => {
    try {
      loading = true
      fileTempModal = false

      //loading Font Library
      await loadFontLibrary()

      // Loading base Image
      let image = await loadImage($fileTemplateState.baseImageInfo.uri)

      $fileTemplateState.baseImageInfo.height = image.naturalHeight
      $fileTemplateState.baseImageInfo.width = image.naturalWidth

      // tempLayers (local storage layer)
      $fileTemplateState.operations = tempLayers
      $fileTemplateState.tempOperation = tempLayers

      // redrawing image layers
      await redrawImageLayers()

      $fileTemplateState.operations = $fileTemplateState.operations.map((opp) => {
        if (opp.type == "text") {
          opp.errorX = opp.x < 0 || opp.x > $fileTemplateState.baseImageInfo.width
          opp.errorY = opp.y < 0 || opp.y > $fileTemplateState.baseImageInfo.height
        } else {
          opp.errorX = opp.x < 0 || opp.x + opp.width > $fileTemplateState.baseImageInfo.width
          opp.errorY = opp.y < 0 || opp.y + opp.height > $fileTemplateState.baseImageInfo.height
        }
        return opp
      })
      // updating local storage
      localStorage.setItem("P2BFileTempEditor", JSON.stringify($fileTemplateState))

      $fileTemplateState.showImageSection = true
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File Template Editor\nEVENT: While resuming with local file template data"
      closeNotification = notify.danger(error, info)
      push("/templates/file")
    } finally {
      loading = false
    }
  }

  const onStartAgain = async () => {
    try {
      loading = true

      fileTempModal = false

      //loading Font Library
      $fileTemplateState.fonts = apiFontIds
      await loadFontLibrary()

      // Loading base Image
      let image = await loadImage($fileTemplateState.baseImageInfo.uri)

      $fileTemplateState.baseImageInfo.height = image.naturalHeight
      $fileTemplateState.baseImageInfo.width = image.naturalWidth

      for (let i = 0; i < apiLayers.length; i++) {
        apiLayers[i].id = i
        apiLayers[i].active = false
        apiLayers[i].hover = false
        apiLayers[i].save = false
      }

      $fileTemplateState.operations = apiLayers

      if ($fileTemplateState.operations.length) {
        let flatObject = flatenObject($fileTemplateState.parsedJson)

        for (let i = 0; i < $fileTemplateState.operations.length; i++) {
          if ($fileTemplateState.operations[i].type == "text") {
            if (flatObject[$fileTemplateState.operations[i].attribute]) {
              $fileTemplateState.operations[i].value = flatObject[$fileTemplateState.operations[i].attribute]
            } else {
              if (!$fileTemplateState.operations[i].value) $fileTemplateState.operations[i].value = "Enter your text"
            }
          }
        }
      }

      // }
      $fileTemplateState.tempOperation = apiLayers

      // redrawing image layers
      await redrawImageLayers()

      // updating local storage
      localStorage.setItem("P2BFileTempEditor", JSON.stringify($fileTemplateState))
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File Template Editor\nEVENT: While resuming with API file template data"
      closeNotification = notify.danger(error, info)
      throw error
    } finally {
      loading = false
    }
  }

  const redrawImageLayers = () => {
    return new Promise(async (resolve, reject) => {
      try {
        if ($fileTemplateState.operations.length) {
          for (let i = 0; i < $fileTemplateState.operations.length; i++) {
            if ($fileTemplateState.operations[i].type == "image") {
              if ($fileTemplateState.operations[i].dynamic) {
                $fileTemplateState.operations[i].src = drawChecked($fileTemplateState.operations[i].width, $fileTemplateState.operations[i].height)
                $fileTemplateState.operations[i].image = await loadImage($fileTemplateState.operations[i].src)
                $fileTemplateState.operations[i].uploadImage = true
              } else {
                if ($fileTemplateState.operations[i].src && $fileTemplateState.operations[i].src.startsWith("/ipfs")) {
                  $fileTemplateState.operations[i].image = await loadImage($fileTemplateState.operations[i].src)
                } else {
                  $fileTemplateState.operations[i].src = drawChecked($fileTemplateState.operations[i].width, $fileTemplateState.operations[i].height)
                  $fileTemplateState.operations[i].image = await loadImage($fileTemplateState.operations[i].src)
                  $fileTemplateState.operations[i].uploadImage = true
                }
              }
            }

            if ($fileTemplateState.operations[i].type == "qr") {
              $fileTemplateState.operations[i].bgColor = $fileTemplateState.operations[i].bgColor || "#ffffff"
              $fileTemplateState.operations[i].color = $fileTemplateState.operations[i].color || "#000000"
              let qrImage = await QRCode.toDataURL("https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592", {
                color: {
                  light: $fileTemplateState.operations[i].bgColor,
                  dark: $fileTemplateState.operations[i].color,
                },
              })

              // let qrImage = await QRCode.toDataURL("https://view.demo.print2block.in/docs/8349c8d73fb16a960b02dec9047bcc2c517497243375dd3247c47399dda31592")
              $fileTemplateState.operations[i].image = await loadImage(qrImage)
            }
          }
        }
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  /**
   * @description function for drawing the checked image
   * @param side
   */
  const drawChecked = (width, height) => {
    let size

    if (width <= height) size = width
    else size = height

    let canvas = document.createElement("canvas")
    canvas.width = width
    canvas.height = height

    let ctx = canvas.getContext("2d")
    ctx.fillStyle = "#909090"
    ctx.fillRect(0, 0, width, height)

    const ICON_WIDTH = 512

    const SCALING_FACTOR = size / 3 / ICON_WIDTH

    let pathData = "M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"

    const path = new Path2D(pathData)
    ctx.save()
    ctx.setTransform(SCALING_FACTOR, 0, 0, SCALING_FACTOR, width / 2 - (512 * SCALING_FACTOR) / 2, height / 2 - (512 * SCALING_FACTOR) / 2)

    ctx.fillStyle = "#ffffff"
    ctx.fill(path)
    ctx.restore()

    return canvas.toDataURL()
  }

  let countDownTimer = setInterval(() => {
    if (countdown > 0) {
      countdown = Math.round((countdown - 1) * 10) / 10
    } else {
      clearInterval(countDownTimer)
    }
  }, 1000)

  const footerNotification = () => {
    $fileTemplateState.operations.map((operation) => {
      if (operation.active) {
        if (operation.type == "text") {
          $fileTemplateState.footerArray = ["You can change the Layer Name and Value", "You can apply different font families", "Apply color on your wish", "Apply font styles based on your interest", "Able to move and drag the text"]
        } else if (operation.type == "image") {
          $fileTemplateState.footerArray = ["You can able to change the Layer Name", "Able to toggle static/dynamic", "Able to move and drag the image", "Able to maintain the aspect ratio of the image"]
        } else {
          $fileTemplateState.footerArray = ["Able to move and drag the qr", "Able to maintain the aspect ratio of the qr"]
        }
      } else {
        $fileTemplateState.footerArray = ["You can change the quality in settings", "Add or Edit, Text, Image and qr elements", "You can Add custom fonts for text layers", "You can Able to change File template name", "Able to Download the canvas"]
      }
    })
  }

  let timer = setInterval(() => {
    $fileTemplateState.notifyFooter = "Auto Saving.."
    localStorage.setItem("P2BFileTempEditor", JSON.stringify($fileTemplateState))
    setTimeout(() => {
      footerNotification()
      $fileTemplateState.notifyFooter = ""
    }, 1000)
  }, 30000)

  onDestroy(() => {
    clearTimeout(timer)
  })

  // Deleting the file template for particular id
  const deleteTemplate = async () => {
    try {
      await deleteRequest(`/api/swagger/v2/templates/files/${$fileTemplateState.baseImageInfo.id}`, {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      })

      $ApplicationState.templateDel = false
      notify.success(`<strong style="hyphens: auto;">${$fileTemplateState.baseImageInfo.name}</strong> deleted successfully`)
      push("/templates/file")
    } catch (error) {
      const info = "PAGE: File Template Editor\nEVENT: While deleting file template"
      notify.danger(error, info)
    }
  }
</script>

{#if loading}
  <LoadingScreen />
{/if}

<svelte:head>
  <title>File Design Template Editor</title>
</svelte:head>
{#if !$fileTemplateState.showImageSection && !fileTempModal && !$fileTemplateState.baseImageUploadModal && !$fileTemplateState.GoBackModal && !$ApplicationState.templateDel}
  <div class="fixed inset-0 z-20 flex items-center justify-center">
    <div class="h-20 w-20 animate-spin rounded-full border-[1px] border-gray-300 border-r-blue-500" />
  </div>
{/if}
{#if showEditor}
  <div class="relative">
    <div class="fixed top-0 left-0 z-20 flex h-screen w-screen select-none bg-gray-c00">
      {#if $fileTemplateState.baseImageUploadModal}
        <UploadFile />
      {/if}
      <div class="z-10 flex h-full w-[5%] flex-col items-center justify-between bg-[#292A2F] p-3">
        <NavBar />
      </div>
      <div class="relative -z-[5] h-full w-full">
        {#if $fileTemplateState.showImageSection && !fileTempModal}
          <ImgSection />
        {/if}
      </div>
      <div style="height:calc(100% - 40px);" class="flex flex-col gap-3 bg-gray-c00 p-3">
        {#if $fileTemplateState.showImageSection}
          <TitleCard />
          <Layers on:click />
        {/if}
      </div>
      <div class="absolute bottom-0 w-full">
        <!-- <div class="absolute bottom-8 w-full translate-y-1/2 px-12 py-2"> -->
        <Footer />
      </div>
    </div>
  </div>
{:else}
  <div class="h-screen w-screen bg-gray-c00">
    <div class="flex h-full w-full select-none flex-col items-center justify-center p-5">
      <h1 class="text-center text-lg font-bold text-blue-500">The Minimum screen resolution should be 1024px</h1>
      <h1 class="text- pt-2 font-bold text-gray-g00">
        Your screen resolution is {window.innerWidth}px X {window.innerHeight}px
      </h1>
      <h1 class="pt-2 text-sm font-bold text-gray-g00">
        Redirecting in <strong class="text-red-500">{countdown}</strong>
        seconds
      </h1>
    </div>
  </div>
{/if}

{#if $defaultFonts.addCustomFont}
  <CustomFont />
{/if}
{#if $defaultFonts.newFontListModal}
  <AddFontToList bind:tempState={$fileTemplateState} />
{/if}
{#if fileTempModal}
  <FileTempModal
    on:click={onResume}
    on:startAgain={async () => {
      await onStartAgain()
      $fileTemplateState.showImageSection = true
    }}
  />
{/if}
{#if $fileTemplateState.templateDel}
  <ModalDelete on:delete={deleteTemplate} />
{/if}
{#if $fileTemplateState.goBack}
  <GoBackModal />
{/if}
